import React from 'react';
import Navigation from '../components/Navigation';
import Gallery from '../components/Gallery';
import Footer from '../components/Footer';
import { series } from '../mock';

const WorksPage = () => {
  return (
    <div className="min-h-screen bg-off-black">
      <Navigation />

      {/* Content with top padding */}
      <div className="pt-20 sm:pt-24">
        <Gallery series={series} />
      </div>
      <Footer />
    </div>
  );
};

export default WorksPage;
